import { Toaster as Sonner } from "sonner";

import { useTheme } from "../../context/ThemeContext";

const Toaster = ({ ...props }) => {
  const { theme } = useTheme();

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      containerStyle={{
        zIndex: 1000000
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton:
            "!left-auto !-right-4 !top-0 opacity-100 bg-white dark:bg-yale-blue-900 text-yale-blue-500 dark:text-slate-400 border-slate-200 dark:border-yale-blue-800 hover:bg-yale-blue-50 dark:hover:bg-yale-blue-800 transition-all shadow-sm"
        }
      }}
      {...props}
    />
  );
};

export { Toaster };
